module.exports = "https://infinity-call.servercdn.it/static/img/right.jpg?ad5c0a54f986cb8715827dd00ee79ef3";